import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import DynamicTable from "../../Components/Table/DynamicTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchComplainData } from "../../Redux/Slice/ShowAllTask";
import { useNavigate } from "react-router-dom";
import ShowMainTask from "./Components/ShowMainTask/ShowMainTask";

const ShowAllTask = () => {
  // const loginData = Cookies.get("loginData");
  // const parsedData = loginData ? JSON.parse(loginData) : null;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { id } = useParams();

  const { ComplainData } = useSelector((state) => state.ShowAllTask);

  const [filters, setFilters] = useState({
    tokenName: "",
    companyName: "",
    project: "",
    supportTeam: "",
    status: "",
    todayOnly: false,
    startDate: "", // Start date for date range filter
    endDate: "", // End date for date range filter
  });

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  const isToday = (isoDate) => {
    const today = new Date();
    const date = new Date(isoDate);
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  useEffect(() => {
    dispatch(fetchComplainData());
  }, [dispatch]);

  // const handleFilterChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFilters({
  //     ...filters,
  //     [name]: type === "checkbox" ? checked : value,
  //   });
  // };

  const handleFilterChange = (e) => {
    if (e?.target) {
      // Native event (input/select/checkbox)
      const { name, value, type, checked } = e.target;
      setFilters((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    } else if (e?.name) {
      // Custom object (Autocomplete, etc.)
      setFilters((prev) => ({
        ...prev,
        [e.name]: e.value,
      }));
    }
  };

  const isDateInRange = (isoDate, startDate, endDate) => {
    const date = new Date(isoDate);
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (startDate && endDate) {
      return date >= start && date <= end;
    }
    return true;
  };

  // Extract unique options for dropdowns
  const companyNameOptions = [
    ...new Set(ComplainData?.data?.map((el) => el.CompanyName?.WhaClientName)),
  ].filter(Boolean).sort((a, b) => a.localeCompare(b));

  const projectOptions = [
    ...new Set(ComplainData?.data?.map((el) => el.Project?.project_name)),
  ].filter(Boolean).sort((a, b) => a.localeCompare(b));

  const supportTeamOptions = [
    ...new Set(ComplainData?.data?.map((el) => el.SuportTeamId?.Name)),
  ].filter(Boolean).sort((a, b) => a.localeCompare(b));

  const statusOptions = [
    ...new Set(ComplainData?.data?.map((el) => el.Status)),
  ].filter(Boolean).sort((a, b) => a.localeCompare(b));

  const projects = [
    { id: 2, label: "Website Redesign" },
    { id: 3, label: "Mobile App" },
    { id: 4, label: "Marketing Campaign" },
  ];

  // Separate states for each Autocomplete
  const [companyValue, setCompanyValue] = useState(null);
  const [companyInput, setCompanyInput] = useState("");

  const [projectValue, setProjectValue] = useState(null);
  const [projectInput, setProjectInput] = useState("");

  const [statusValue, setStatusValue] = useState(null);
  const [statusInput, setStatusInput] = useState("");

  const ComplainColumns = [
    { field: "tokenName", headerName: "Token Name", flex: 1 },
    { field: "companyName", headerName: "Company Name", flex: 1 },
    { field: "Project", headerName: "Project", flex: 1 },
    { field: "SuportTeamId", headerName: "Support Team", flex: 1 },
    { field: "Date", headerName: "Date", flex: 1 },
    { field: "Status", headerName: "Status", flex: 1 },
  ];

  const filteredRows = ComplainData?.data
    ?.filter((el) => {
      const {
        tokenName,
        companyName,
        project,
        supportTeam,
        status,
        todayOnly,
        startDate,
        endDate,
      } = filters;

      const matchesTokenName =
        !tokenName ||
        el.CallNo?.toLowerCase().includes(tokenName?.toLowerCase());
      const matchesCompanyName =
        !companyName || el.CompanyName?.WhaClientName === companyName;
      const matchesProject = !project || el.Project?.project_name === project;
      const matchesSupportTeam =
        !supportTeam || el.SuportTeamId?.Name === supportTeam;
      const matchesStatus = !status || el?.Status === status;
      const matchesToday = !todayOnly || isToday(el?.Date);
      const matchesDateRange = isDateInRange(el?.Date, startDate, endDate); // Check if the date falls in the range

      return (
        matchesTokenName &&
        matchesCompanyName &&
        matchesProject &&
        matchesSupportTeam &&
        matchesStatus &&
        matchesToday &&
        matchesDateRange
      );
    })
    .map((el, index) => ({
      id: index + 1,
      tokenName: el.CallNo,
      companyName: el.CompanyName?.WhaClientName,
      Project: el.Project?.project_name,
      SuportTeamId: el.SuportTeamId?.Name,
      Date: formatDate(el.Date),
      MainId: el?._id, // Include MainId for navigation
      Status: el?.Status,
    }))
    .reverse();

  const handleRowClick = (row) => {
    // const mainId = params?.row?.MainId;
    navigate(`/ShowAllTask/CustomerrequustDetail/${row.MainId}`); // Navigate to target page with MainId
  };

  return (
    <>
      <div>
        {/* ====================== Show All Customer Request ============================ */}

        <div className="subTitle my-5">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            Show All Customer Request
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-md rounded-md mt-4">
          <div className="grid grid-cols-12 gap-4 p-4 rounded-2xl">
            <div className="col-span-12 flex items-center gap-2">
              <input
                type="checkbox"
                name="todayOnly"
                id="todayOnly"
                checked={filters.todayOnly}
                onChange={handleFilterChange}
                className="w-5 h-5"
              />
              <label htmlFor="todayOnly" className="my-2 font-semibold">
                Show Today Only
              </label>
            </div>

            {/* Token Name */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Token Name</h5>
              <input
                type="text"
                placeholder="Enter Token Name"
                name="tokenName"
                value={filters.tokenName}
                onChange={handleFilterChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 rounded border-black"
              />
            </div>

            {/* Company Name Autocomplete */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Company Name</h5>
              <Autocomplete
                className="custom-input"
                options={companyNameOptions?.map((name) => ({ label: name }))}
                getOptionLabel={(option) => option?.label}
                value={
                  filters?.companyName ? { label: filters?.companyName } : null
                }
                onChange={(e, newVal) =>
                  handleFilterChange({
                    name: "companyName",
                    value: newVal?.label || "",
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Enter Company Name"
                    size="small"
                  />
                )}
              />
            </div>

            {/* Project Autocomplete */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Project</h5>
              <Autocomplete
                className="custom-input"
                options={projectOptions?.map((name) => ({ label: name }))}
                getOptionLabel={(option) => option?.label}
                value={filters.project ? { label: filters?.project } : null}
                onChange={(e, newVal) =>
                  handleFilterChange({
                    name: "project",
                    value: newVal?.label || "",
                  })
                }
                isOptionEqualToValue={(option, value) =>
                  option.label === value?.label
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Enter Project"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </div>

            {/* Support Team Autocomplete */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Support Team</h5>
              <Autocomplete
                className="custom-input"
                options={supportTeamOptions?.map((name) => ({ label: name }))}
                getOptionLabel={(option) => option?.label}
                value={
                  filters.supportTeam ? { label: filters.supportTeam } : null
                }
                onChange={(e, newVal) =>
                  handleFilterChange({
                    name: "supportTeam",
                    value: newVal?.label || "",
                  })
                }
                isOptionEqualToValue={(option, value) =>
                  option.label === value?.label
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Enter Support Team"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </div>

            {/* Status Autocomplete */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Status</h5>
              <Autocomplete
                className="custom-input"
                options={statusOptions?.map((name) => ({ label: name }))}
                getOptionLabel={(option) => option?.label}
                value={filters.status ? { label: filters.status } : null}
                onChange={(e, newVal) =>
                  handleFilterChange({
                    name: "status",
                    value: newVal?.label || "",
                  })
                }
                isOptionEqualToValue={(option, value) =>
                  option.label === value?.label
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Enter Status"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </div>

            {/* Start & End Dates */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Start Date</h5>
              <input
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={handleFilterChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 rounded border-black"
              />
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">End Date</h5>
              <input
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={handleFilterChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 rounded border-black"
              />
            </div>
          </div>
        </div>

        <div className="divider my-5">
          <DynamicTable
            rows={filteredRows}
            columns={ComplainColumns}
            onRowClick={handleRowClick}
          />
        </div>

        {/* ====================== Show Main Task ============================ */}

        <ShowMainTask />

        {/* ========================= Show Sub Task ======================== */}

        <div className="subTitle my-5">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            Show Sub Task
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-md rounded-md mt-4">
          <div className="grid grid-cols-12 gap-4 p-4 rounded-2xl">
            <div className="col-span-12 flex items-center gap-2">
              <input type="checkbox" id="showToday" className="w-5 h-5" />
              <label htmlFor="showToday" className="my-2 font-semibold">
                Show Today Only
              </label>
            </div>

            {/* Task Name Autocomplete */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Task Name</h5>
              <input
                type="text"
                placeholder="Enter Token Name"
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
            </div>

            {/* Assign By Autocomplete */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Assign By</h5>
              <Autocomplete
                options={projects}
                getOptionLabel={(option) => option.label}
                value={companyValue}
                onChange={(e, newVal) => setCompanyValue(newVal)}
                inputValue={companyInput}
                onInputChange={(e, newInput) => setCompanyInput(newInput)}
                isOptionEqualToValue={(option, value) =>
                  option.id === value?.id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="custom-input"
                    placeholder="Enter Company Name"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </div>

            {/* Assigned To Autocomplete */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Assigned To</h5>
              <Autocomplete
                options={projects}
                getOptionLabel={(option) => option.label}
                value={projectValue}
                onChange={(e, newVal) => setProjectValue(newVal)}
                inputValue={projectInput}
                onInputChange={(e, newInput) => setProjectInput(newInput)}
                isOptionEqualToValue={(option, value) =>
                  option.id === value?.id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="custom-input"
                    placeholder="Enter Project"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </div>

            {/* Status Autocomplete */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Status</h5>
              <Autocomplete
                options={projects}
                getOptionLabel={(option) => option.label}
                value={statusValue}
                onChange={(e, newVal) => setStatusValue(newVal)}
                inputValue={statusInput}
                onInputChange={(e, newInput) => setStatusInput(newInput)}
                isOptionEqualToValue={(option, value) =>
                  option.id === value?.id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="custom-input"
                    placeholder="Enter Status"
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </div>

            {/* Start & End Dates */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Start Date</h5>
              <input
                type="date"
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">End Date</h5>
              <input
                type="date"
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
            </div>
          </div>
        </div>

        <div className="divider my-5">
          <DynamicTable />
        </div>
      </div>
    </>
  );
};

export default ShowAllTask;
